
export default {
  name: 'ShowHide',
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    sortList: {
      type: Boolean,
      default: true,
    },
    ctaMoreText: {
      type: String,
      default: '',
    },
    ctaLessText: {
      type: String,
      default: '',
    },
    theme: {
      type: String,
      default: 'standart',
      validator(value) {
        return ['standart', 'simple'].includes(value)
      },
    },
    mobileCount: {
      type: Number,
      default: 4,
    },
    desktopCount: {
      type: Number,
      default: 8,
    },
    buttonSticky: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      expanded: false,
    }
  },
  computed: {
    itemsVisible() {
      if (!this.list || !Array.isArray(this.list)) return []
      const sortedListByName = this.sortList
        ? [...this.list].sort((previous, current) =>
            previous.title?.localeCompare(current.title),
          )
        : [...this.list]
      if (this.expanded) return sortedListByName
      if (this.$store.getters['resize/isMobile']) {
        return sortedListByName?.slice(0, this.mobileCount)
      }
      return sortedListByName?.slice(0, this.desktopCount)
    },
    ctaText() {
      return this.expanded ? this.ctaLessText : this.ctaMoreText
    },
    isExpandable() {
      if (
        this.$store.getters['resize/isMobile'] &&
        this.list?.length < this.mobileCount + 1
      ) {
        return false
      }
      if (
        !this.$store.getters['resize/isMobile'] &&
        this.list?.length < this.desktopCount + 1
      ) {
        return false
      }
      return true
    },
    isOverlay() {
      return !this.expanded && this.isExpandable
    },
  },
}
